import React from "react";
import { CATEGORIES, MOCK_TASKS } from "./mockTasks";
import { Link } from "react-router-dom";

const ALL_RESOURCES = [...new Set(MOCK_TASKS.flatMap((t) => t.team))].sort();

function fmt(date) {
    return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
    });
}

const SELECT_STYLE = {
    paddingLeft: 32,
    paddingRight: 28,
    paddingTop: 7,
    paddingBottom: 7,
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    fontSize: 12,
    color: "#334155",
    background: "#fff",
    cursor: "pointer",
    outline: "none",
    fontWeight: 500,
    appearance: "none",
    WebkitAppearance: "none",
};

const FilterBar = ({

    weekStart,
    onPrev,
    onNext,
    filterResource,
    onResourceChange,
    filterProject,
    onProjectChange,
}) => {
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 4);

    const uniqueProjects = [...new Set(MOCK_TASKS.map((t) => t.title))].sort();

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 12,
                background: "#fff",
                borderRadius: 12,
                padding: "14px 20px",
                marginBottom: 16,
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                border: "1px solid #e2e8f0",
            }}
        >
            {/* ── Left: count pill + week navigator ── */}
            <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
                {/* Count pill */}
                {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 7,
            background: "#eef2ff",
            borderRadius: 20,
            padding: "6px 14px",
          }}
        >
          <i className="fa fa-th-large" style={{ color: "#6366f1", fontSize: 12 }} />
          <span style={{ fontSize: 13, fontWeight: 700, color: "#4f46e5" }}>
            {String(totalCount).padStart(2, "0")} Projects
          </span>
        </div> */}

                {/* Week navigator */}
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <button
                        onClick={onPrev}
                        style={{
                            width: 30,
                            height: 30,
                            borderRadius: "50%",
                            border: "1px solid #e2e8f0",
                            background: "#fff",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#475569",
                            fontSize: 12,
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                    >
                        <i className="fa fa-chevron-left" />
                    </button>

                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <i className="fa fa-calendar" style={{ color: "#94a3b8", fontSize: 13 }} />
                        <span style={{ fontSize: 14, fontWeight: 600, color: "#334155", whiteSpace: "nowrap" }}>
                            {fmt(weekStart)} – {fmt(weekEnd)}
                        </span>
                    </div>

                    <button
                        onClick={onNext}
                        style={{
                            width: 30,
                            height: 30,
                            borderRadius: "50%",
                            border: "1px solid #e2e8f0",
                            background: "#fff",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#475569",
                            fontSize: 12,
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                    >
                        <i className="fa fa-chevron-right" />
                    </button>
                </div>
            </div>

            {/* ── Right: filter dropdowns ── */}
            <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                {/* Resource */}
                <div style={{ position: "relative" }}>
                    <i className="fa fa-user" style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: 11, pointerEvents: "none" }} />
                    <select value={filterResource} onChange={(e) => onResourceChange(e.target.value)} style={SELECT_STYLE}>
                        <option value="">Select Resource</option>
                        {ALL_RESOURCES.map((r) => (
                            <option key={r} value={r}>{r}</option>
                        ))}
                    </select>
                    <i className="fa fa-angle-down" style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: 11, pointerEvents: "none" }} />
                </div>

                {/* Project */}
                <div style={{ position: "relative" }}>
                    <i className="fa fa-folder" style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: 11, pointerEvents: "none" }} />
                    <select value={filterProject} onChange={(e) => onProjectChange(e.target.value)} style={SELECT_STYLE}>
                        <option value="">Select Project</option>
                        {uniqueProjects.map((p) => (
                            <option key={p} value={p}>{p}</option>
                        ))}
                    </select>
                    <i className="fa fa-angle-down" style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: 11, pointerEvents: "none" }} />
                </div>

                <Link
                    to="/project-add"
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        background: "#f20037",
                        color: "#fff",
                        padding: "8px 16px",
                        borderRadius: 8,
                        fontSize: 13,
                        fontWeight: 600,
                        textDecoration: "none",
                        whiteSpace: "nowrap",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "#f20037")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "#f20037")}
                >
                    <i className="fa fa-plus" style={{ fontSize: 11 }} />
                    ADD JOB
                </Link>

            </div>
        </div>
    );
};

export default FilterBar;
